import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _path2;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M11.507 6.8H4.493c-.775 0-1.403.628-1.403 1.403v4.208c0 .775.628 1.403 1.403 1.403h7.014c.774 0 1.402-.628 1.402-1.403V8.203c0-.775-.628-1.403-1.402-1.403Z",
      stroke: "#494E58",
      strokeWidth: 1.3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M5.693 6.8V4.493a2.307 2.307 0 0 1 4.614 0V6.8",
      stroke: "#494E58",
      strokeWidth: 1.3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))]
  }));
};
export default SvgLock;